import ApiClient from '@/api/settings/axios';

const apiClient = new ApiClient();

// 自分の出品リスト
const requestMyList = ({ csrfToken, page = 1, postParams }) => {
  const result = apiClient.post(
    `/user/market/my_list/${page}`,
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

// 出品リスト
const requestList = ({ csrfToken, page = 1, postParams }) => {
  const result = apiClient.post(
    `/user/market/list/${page}`, { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

// 出品処理
const requestSale = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/market/sale',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

// 価格変更
const requestPriceChange = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/market/price_change',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

// カートに追加処理
const requestAddCart = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/market/add_cart',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

// カートから削除
const requestDeleteCart = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/market/cart_delete',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

// カートのチェック
const requestCheckCart = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/market/check_buy',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

// 購入処理
const requestBuy = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/market/buy',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

// PayPal Order作成（サーバー駆動）
const requestMarketPaypalCreateOrder = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/market/paypal/create_order',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

// PayPal Capture（サーバー駆動）
const requestMarketPaypalCaptureOrder = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/market/paypal/capture_order',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

// 入金申請
const requestPayment = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/market/request_payment',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

// 口座かペイパル登録
const requestPaymentSave = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/market/payment_save',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

// 口座かペイパル削除
const requestPaymentDelete = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/market/payment_delete',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

// 以下get______________________________________

// カート一覧
const requestCartList = () => {
  const result = apiClient.get(
    '/user/market/cart_list',
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

// 購入後の処理
const requestBuyComplete = () => {
  const result = apiClient.get(
    '/user/market/buy_complete',
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

// 入金履歴
const requestPaymentHistory = () => {
  const result = apiClient.get(
    '/user/market/payment_history',
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

// 入金する口座かペイパルの詳細
const requestPaymentList = () => {
  const result = apiClient.get(
    '/user/market/payment_list',
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

// 購入履歴
const requestPurchaseList = () => {
  const result = apiClient.get(
    '/user/market/purchase_list',
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

// 購入履歴詳細
const requestPurchaseDetail = ({ id }) => {
  const result = apiClient.get(
    `/user/market/purchase_detail/${id}`,
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

// マーケット選択処理
const requestMarketChoice = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/market/market_choice',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

export {
  requestMyList,
  requestList,
  requestSale,
  requestPriceChange,
  requestAddCart,
  requestCartList,
  requestDeleteCart,
  requestCheckCart,
  requestBuy,
  requestMarketPaypalCreateOrder,
  requestMarketPaypalCaptureOrder,
  requestBuyComplete,
  requestPayment,
  requestPurchaseList,
  requestPaymentHistory,
  requestPurchaseDetail,
  requestPaymentList,
  requestPaymentSave,
  requestPaymentDelete,
  requestMarketChoice,
};
